import { BLACK_ON_WHITE_CSS_CLASS } from '@angular/cdk/a11y/high-contrast-mode/high-contrast-mode-detector';
import { Component, Inject, OnDestroy, OnInit, Optional, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Angular2CsvComponent } from 'angular2-csv';
import * as Highcharts from 'highcharts';
import addMore from "highcharts/highcharts-more";
import { Observable,timer } from 'rxjs';
import { interval, Subscription} from 'rxjs';
import { reduce } from 'rxjs/operators';
import { ApiService } from 'src/app/api.service';
// import { Angular2Csv } from 'angular2-csv/Angular2-csv';
addMore(Highcharts)

@Component({
  selector: 'app-show-poll-result',
  templateUrl: './show-poll-result.component.html',
  styleUrls: ['./show-poll-result.component.scss']
})
export class ShowPollResultComponent implements OnInit, OnDestroy {
   @ViewChild(Angular2CsvComponent) csvComponent: Angular2CsvComponent;
   @ViewChild(MatPaginator) paginator: MatPaginator;
   @ViewChild(MatSort) sort: MatSort;
   displayedColumns: string[] = ['member_name','division','response','parsed_response','replied','id'] ;
   dataSource :any;
   showSpinner = false;
   smsInfoUrl;
   pollResultId;
   pollResult;
   OptionSpecificResult = [];
   poll;
   pollexecute;
   pollOptions = [];
   correctOptiion;
   highcharts1 = Highcharts;
   chartOptions1:any
   test :any = []
   hideStopexecutingButton = false;
   name = 'Angular 6';
   status: any[];
   formula:string = "Formula 1";

   private timeValue: Subscription;
   private timeValue1: Subscription;
   showProgressBar = false;
   private timer;
   value = 0;
   valueInstance;

  constructor(public dialogRef: MatDialogRef<ShowPollResultComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar
    
    ) {
      // this.showSpinner = true;
      this.pollResultId = data.id;
      this.highcharts1 = Highcharts;
     }

  ngOnInit(): void {
   this.showSpinner = true;
   this.smsInfoUrl = window.location.origin + '/home/sms-detail/';
   // this.smsInfoUrl = window.location.origin + '/home/groups';
   console.log(this.smsInfoUrl);
   
   
   this._apiService.pollResultsList(this.pollResultId).subscribe(res => {
      if (res) {
         this.showSpinner = false;
         console.log( res)
         this.OptionSpecificResult = res.results;
         this.dataSource = new MatTableDataSource<pollResultLists>(res.results);
         setTimeout(() => this.dataSource.paginator = this.paginator);
         setTimeout(() => this.dataSource.sort = this.sort);
         this.poll = res.poll;
         this.pollexecute = res.poll_execute;
         this.pollOptions = res.poll_options;
         this.correctOptiion = res.poll_options.filter(ele => ele.id == res.poll.correct_option)[0];
         console.log(this.correctOptiion);
         this.handledata();
         this.progressBarInfo();
      }
   },
   (error)=>{
      this.showSpinner = false;
      this._snackBar.open('Error Occured : '+error, 'OK', { duration: 3000 });
   });
   


  }
  refreshPollResult(){
   // this.showSpinner = true;
   this._apiService.pollResultsList(this.pollResultId).subscribe(res => {
      if (res) {
         this.showSpinner = false;
         console.log( res)
         this.OptionSpecificResult = res.results;
         this.dataSource = new MatTableDataSource<pollResultLists>(res.results);
         setTimeout(() => this.dataSource.paginator = this.paginator);
         setTimeout(() => this.dataSource.sort = this.sort);
         this.poll = res.poll
         this.pollexecute = res.poll_execute
         this.pollOptions = res.poll_options
         this.handledata();
         let resultInstance = [];
         for(let i=0; i<this.OptionSpecificResult.length; i++){
            if(this.OptionSpecificResult[i].replied == false){
               resultInstance.push(this.OptionSpecificResult[i]);
            }
         }
         if(resultInstance.length == 0 && this.poll.allow_vote_change == false){
            this.cpmpletePollExecutionForspecificexecution();
         }
      }
   },
   (error)=>{
      // this.showSpinner = false;
      this._snackBar.open('Error Occured : '+error, 'OK', { duration: 3000 });
   });
  }

  progressBarInfo(){
   let today = new Date();
   let date = new Date(this.OptionSpecificResult[0].created_at);
   let timeInMilisec = Math.floor(( today.getTime() - date.getTime() ) );
   let effectiveTime = timeInMilisec - this.poll.expiry_time*1000;
   console.log(effectiveTime)
   let timediff = this.poll.expiry_time*10;
   this.valueInstance = timeInMilisec/timediff;
   this.value = this.valueInstance;
   console.log(this.valueInstance)
   console.log(timeInMilisec);
   if(effectiveTime < 0  && this.pollexecute.completed == false){
      this.showProgressBar = true;
      this.timeValue = interval(timediff).subscribe(x => {
         this.value = this.valueInstance + x ;
         if(this.value<100){
            console.log('inside progressbar controller.')
            console.log(x);
         }else{
            this.showProgressBar = false;
            this.cpmpletePollExecution();
            this.timeValue.unsubscribe();
            this.timeValue1.unsubscribe();
         }
      });
   } else {
      this.cpmpletePollExecutionafterCompletion();
   }

   if(this.pollexecute.completed == false){
      this.timeValue1 = interval(30000).subscribe(x => {
         if(this.valueInstance >99){
            this.timeValue1.unsubscribe();
         }
         this.refreshPollResult();
         console.log(x);
         
      });
   }
    

    




   //  const numbers = timer(3000, timediff);
   //  numbers.subscribe(x => {
   //    this.value = x;
   //    if(x<100){
   //      this.value = x;
   //    }else{
   //      this.showProgressBar = false;
   //    }
   //    // this.onTimeOut()
   //  });
  }

  checkForAllReplays(){
   let resultInstance = [];
   for(let i=0; i<this.OptionSpecificResult.length; i++){
      if(this.OptionSpecificResult[i].replied == false){
         resultInstance.push(this.OptionSpecificResult[i]);
      }
   }
   if(resultInstance.length == 0 && this.poll.allow_vote_change == false){
      this.cpmpletePollExecutionForspecificexecution();
   }
  }

  onTimeOut() {
    console.log('test');
  }

  ngOnDestroy(): void {
     if(this.timeValue1){
      this.timeValue1.unsubscribe();
     }
     if(this.timeValue){
      this.timeValue.unsubscribe();
     }
   
   // this.timeValue.unsubscribe();
 }

   handledata = () =>{
      let temp = {"No Reply":0,"Invalid Votes":0}
      this.pollOptions.forEach(element =>{
         temp[element.name] = 0
      })
      this.OptionSpecificResult.forEach(element =>{
         if ( element.matched_option>0){
            temp[element.parsed_response] = temp[element.parsed_response] +1
         }
         else if(element.replied && element.matched_option == 0){
            temp["Invalid Votes"] = temp["Invalid Votes"] + 1
         }
         else{
            temp["No Reply"] = temp["No Reply"]+1
         }
      })
      console.log("temp is",Object.keys(temp))
      console.log("temp is",Object.values(temp))
      let instance =[];
      for(var i =0; i <Object.values(temp).length; i++){
         if(this.poll.poll_type == 'quiz' && this.poll.correct_option){
            if(Object.keys(temp)[i] == this.correctOptiion.name){
               let testInstance = { name: Object.keys(temp)[i], data: [Object.values(temp)[i]], color:'green'}
               instance.push(testInstance);
            }else{
               let testInstance = { name: Object.keys(temp)[i], data: [Object.values(temp)[i]]}
               instance.push(testInstance);
            }
         }else{
            let testInstance = { name: Object.keys(temp)[i], data: [Object.values(temp)[i]]}
            instance.push(testInstance);
         }
         
         
      }

      console.log(instance);
      this.chartHandler(instance, Object.values(temp))
   }
   chartHandler = (series,categories)=> {
 
    this.chartOptions1 = {   
   chart: {
      type: 'column'
   },
   title: {
      text: this.poll.name
   },
   subtitle:{
      text: 'Poll Message: '+this.poll.message
   },
   xAxis:{
      categories: [
         'Votes'
       ]
   },     
   yAxis : {
      min: 0,
      title: {
         text: 'Vote Counts'         
      }      
   },
   tooltip : {
      headerFormat: '<span style = "font-size:10px">{point.key}</span><table>',
      pointFormat: '<tr><td style = "color:{series.color};padding:0">{series.name}: </td>' +
         '<td style = "padding:0"><b>{point.y:.1f} vote</b></td></tr>', footerFormat: '</table>', shared: true, useHTML: true
   },
   plotOptions : {
      column: {
         pointPadding: 0.2,
         borderWidth: 0
      }
   },
   series: series.reverse()
};


   }
 options;
 data1;
 downloadCSV() {
   if(this.poll.poll_type == 'quiz' && this.poll.correct_option){
      this.options = {
         fieldSeparator: ',',
         quoteStrings: '"',
         decimalseparator: '.',
         showLabels: false,
         headers: ['Member Name','From','To','Replied','Poll Execution Time','Last Replied Time', 'Inbound Sid', 'Outbound Sid', 'Company Id','Error Code','Error','Response','Matched Option','Correct Answer'],
         showTitle: true,
         title: this.poll.name,
         useBom: false,
         removeNewLines: true,
         keys: ['member_name','from','to','replied','created_at','updated_at', 'inbound_sid', 'outbound_sid', 'company_id','error_code','error','response','parsed_response','CorrectAnswer' ]
       };
      let optionSpecificResultForDownload = [];
      let instance = {};
      for(let i=0; i<this.OptionSpecificResult.length; i++){
         instance = this.OptionSpecificResult[i];
         if(this.OptionSpecificResult[i].matched_option == this.poll.correct_option){
            instance['CorrectAnswer'] = true;
         }else {
            instance['CorrectAnswer'] = false;
         }
         if(!this.OptionSpecificResult[i].parsed_response){
            instance['parsed_response'] = 'No Reply'
         }
         console.log(instance);
         optionSpecificResultForDownload.push(instance);
      }
      this.data1 = optionSpecificResultForDownload;
      setTimeout(() => { this.csvComponent.onDownload(); }, 0);
   }else {
      this.options = {
         fieldSeparator: ',',
         quoteStrings: '"',
         decimalseparator: '.',
         showLabels: false,
         headers: ['Member Name','From','To','Replied','Division','Poll Execution Time','Last Replied Time', 'Inbound Sid', 'Outbound Sid', 'Company Id','Error Code','Error','Response','Matched Option'],
         showTitle: true,
         title: this.poll.name,
         useBom: false,
         removeNewLines: true,
         keys: ['member_name','from','to','replied','division', 'created_at','updated_at', 'inbound_sid', 'outbound_sid', 'company_id','error_code','error','response','parsed_response' ]
      };
      let optionSpecificResultForDownload = [];
      let instance = {};
      for(let i=0; i<this.OptionSpecificResult.length; i++){
         instance = this.OptionSpecificResult[i];
         if(!this.OptionSpecificResult[i].parsed_response){
            instance['parsed_response'] = 'No Reply'
         }
         console.log(instance);
         optionSpecificResultForDownload.push(instance);
      }
      this.data1 = optionSpecificResultForDownload;
      setTimeout(() => { this.csvComponent.onDownload(); }, 0);
   }
   
   // new Angular2Csv(data, this.formula, options);
 }

 close(){
   this.dialogRef.close();
 }

 cpmpletePollExecutionForspecificexecution(){
    this.cpmpletePollExecution();
    this.showProgressBar = false;
    this.hideStopexecutingButton = true;
 }

 cpmpletePollExecution(){
    this._apiService.cpmpletePollExecution(this.pollexecute.id).subscribe(res => {
      if (res) {
         console.log( res)
         this.dialogRef.close();
      }
   },
   (error)=>{
      this._snackBar.open('Error Occured : '+error, 'OK', { duration: 3000 });
   });
 }

 cpmpletePollExecutionafterCompletion(){
   this._apiService.cpmpletePollExecution(this.pollexecute.id).subscribe(res => {
     if (res) {
        console.log( res)
     }
  },
  (error)=>{
     this._snackBar.open('Error Occured : '+error, 'OK', { duration: 3000 });
  });
}

startVoteingForLivePoll(){
   this._apiService.startLivePollVoteing(this.pollexecute.id).subscribe(res => {
      if (res) {
         console.log( res)
         this.refreshPollResult();
      }
   },
   (error)=>{
      this._snackBar.open('Error Occured : '+error, 'OK', { duration: 3000 });
   });
}

sendReminder(){
   this._apiService.sendReminder(this.pollexecute.id).subscribe(res => {
      if (res) {
         this._snackBar.open(res, 'OK', { duration: 3000 });
         console.log( res)
      }
   },
   (error)=>{
      this._snackBar.open('Error Occured : '+error, 'OK', { duration: 3000 });
   });
}

 
}

export interface pollResultLists {
   company_id: number;
   created_at: string;
   error: string;
   error_code: number;
   from: string;
   id: number;
   inbound_sid: string;
   matched_option: number;
   member_id: number;
   member_name: string;
   outbound_sid: string;
   parsed_response: string;
   poll_execute_id: number;
   poll_id: number;
   replied: boolean;
   response: string;
   status: string;
   to: string;
   updated_at: string;
   division:string;
 };
